import { RootState } from '../../store';

export const getCategoriesSelector = (state: RootState) => state?.ticketReducer?.categories;
